import * as React from 'react';

import { cn } from '@/lib/cn';

export type InputProps = React.ComponentProps<'textarea'>;

function TextArea({ className, ref, ...props }: InputProps) {
  return (
    <textarea
      className={cn(
        'flex w-full rounded-md border border-input bg-surface px-4 py-3 text-sm shadow-input ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground/70 focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:outline-hidden disabled:cursor-not-allowed disabled:opacity-50',
        className
      )}
      ref={ref}
      {...props}
    ></textarea>
  );
}

export { TextArea };
